export function egLogo() {
    return {
        restrict: 'E',
        scope: {},
        bindToController: {
            size: '@size'
        },
        controller: EgLogoController,
        controllerAs: 'vm',
        templateUrl: 'app/components/eg-logo.directive.html'
    };
}

class EgLogoController {
    /* @ngInject */
    constructor(destinationService) {
        this.url = '/resources/client/images/eg-logo.png';

        destinationService.getDestinationSecurityContext()
            .then(response => {
                if ('EXTRANET' === response){
                    destinationService.getDestinationInstallation()
                        .then(response => {
                            let destinationInstallation = response;
                            if ('BOSTED' === destinationInstallation.type){
                                this.url = '/resources/client/images/EG_SENSUM_logo_bosted_extranet.png';
                            }
                            if ('INCORP' === destinationInstallation.type){
                                this.url = '/resources/client/images/EG_SENSUM_logo_extranet.png';
                            }
                        });
                }
            });
    }
}
EgLogoController.$inject = [];
